"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _controlled = require("../Form/controlled");
var _excluded = ["inputRef", "name", "value", "onChange", "disabled", "display", "onClick", "htmlFor", "style", "className", "children", "defaultValue"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Radio = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _useDefaultValue = (0, _controlled.useDefaultValue)(props, false),
    inputRef = _useDefaultValue.inputRef,
    name = _useDefaultValue.name,
    value = _useDefaultValue.value,
    onChange = _useDefaultValue.onChange,
    disabled = _useDefaultValue.disabled,
    display = _useDefaultValue.display,
    onClick = _useDefaultValue.onClick,
    htmlFor = _useDefaultValue.htmlFor,
    style = _useDefaultValue.style,
    className = _useDefaultValue.className,
    children = _useDefaultValue.children,
    defaultValue = _useDefaultValue.defaultValue,
    htmlProps = (0, _objectWithoutProperties2.default)(_useDefaultValue, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('radio');
  var classes = (0, _classnames2.default)("".concat(prefixCls, "__label"), className, (0, _defineProperty2.default)({}, "".concat(prefixCls, "__label--block"), display === 'block'));
  var handleChange = function handleChange(e) {
    onChange(e.currentTarget.checked, {
      e: e,
      radio: _objectSpread(_objectSpread({}, props), {}, {
        value: e.currentTarget.checked
      })
    });
  };
  return /*#__PURE__*/_react.default.createElement("label", (0, _extends2.default)({
    ref: ref,
    className: classes,
    style: disabled ? _objectSpread({
      cursor: 'not-allowed'
    }, style) : style,
    htmlFor: htmlFor,
    onClick: function onClick(event) {
      return event.stopPropagation();
    }
  }, htmlProps), /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    ref: inputRef,
    className: prefixCls,
    checked: !!value,
    disabled: disabled,
    onClick: onClick,
    onChange: handleChange,
    value: name
  }), /*#__PURE__*/_react.default.createElement("span", {
    key: "label",
    className: "".concat(prefixCls, "__text")
  }, children));
});
var _default = exports.default = Radio;